import mutations from './mutations'
import actions from './actions'
import getters from './getters'

export default {
  namespaced: true,
  state: {
  	 categoryList:[],
  	 KOLProducts:[],
  	 KOLPackages:[],
  	 copyData:'https://mobile.kolpartner.com',
  },
  mutations,
  actions,
  getters
}



// WEBPACK FOOTER //
// ./src/Shop/store/index.js